/**
 * Convenience re-export so consumers can import from hooks/useOrgLabels.
 * The canonical implementation lives in contexts/org-labels-context.tsx.
 */
export { useOrgLabels, type OrgLabels } from '../contexts/org-labels-context';
